import { render, staticRenderFns } from "./Area.vue?vue&type=template&id=2b1599d6&scoped=true"
import script from "./Area.vue?vue&type=script&lang=js"
export * from "./Area.vue?vue&type=script&lang=js"
import style0 from "./Area.vue?vue&type=style&index=0&id=2b1599d6&prod&scoped=true&lang=css"
import style1 from "./Area.vue?vue&type=style&index=1&id=2b1599d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1599d6",
  null
  
)

export default component.exports